import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Snackbar } from '@mui/material';
import api from '../api';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            const response = await api.login(username, password);
            // Assuming the response contains a token or user info
            localStorage.setItem('token', response.accessToken);
            navigate('/file-manager'); // Redirect to file manager on success
        } catch (err) {
            setError('Invalid username or password');
        }
    };

    const handleCloseSnackbar = () => {
        setError('');
    };

    return (
        <div>
            <h2>Login</h2>
            <form onSubmit={handleLogin}>
                <TextField
                    label="Username"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <Button type="submit" variant="contained" color="primary" fullWidth>
                    Login
                </Button>
            </form>
            <Snackbar
                open={!!error}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={error}
            />
        </div>
    );
};

export default Login;